import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import { Card, CardContent, Grid, MenuItem, Select } from '@mui/material';
import { FormikProps } from 'formik';
import { Setting } from '../../../types/Settings';

const PREFIX = 'settingForm';

const classes = {
  root: `${PREFIX}-root`,
  pointerCursor: `${PREFIX}-pointerCursor`,
};

const StyledCard = styled(Card)(({ theme }) => ({
  [`& .${classes.root}`]: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
      width: '25ch',
    },
  },

  [`& .${classes.pointerCursor}`]: {
    cursor: 'pointer',
  },
}));

export interface SettingInput extends Setting {
  dataType: 'number' | 'boolean' | 'string' | 'object';
}

interface SettingProps {
  formRef: FormikProps<SettingInput>;
}

export default function SettingForm(props: SettingProps) {
  return (
    <StyledCard style={{ maxWidth: 675, margin: '0 auto', padding: '1px 5px' }}>
      <CardContent>
        <form onSubmit={props.formRef.handleSubmit}>
          <Grid container spacing={1}>
            <Grid xs={12} item>
              <TextField
                id='name'
                name='name'
                label='Name'
                value={props.formRef.values.name}
                onChange={props.formRef.handleChange}
                error={props.formRef.touched.name && Boolean(props.formRef.errors.name)}
                helperText={props.formRef.touched.name && props.formRef.errors.name}
                placeholder='Enter Name'
                variant='standard'
                fullWidth
                //  required
                margin='dense'
              />
            </Grid>

            <Grid xs={12} item>
              <TextField
                id='scope'
                name='scope'
                label='Scope'
                value={props.formRef.values.scope}
                onChange={props.formRef.handleChange}
                error={props.formRef.touched.scope && Boolean(props.formRef.errors.scope)}
                helperText={props.formRef.touched.scope && props.formRef.errors.scope}
                placeholder='Enter Scope'
                variant='standard'
                fullWidth
                required
                margin='dense'
              />
            </Grid>

            <Grid xs={12} item>
              <Select
                variant='outlined'
                id='dataType'
                name='dataType'
                label='DataType'
                size='small'
                value={props.formRef.values.dataType}
                onChange={props.formRef.handleChange}
                // helperText={props.formRef.touched.dataType && props.formRef.errors.dataType}
                error={props.formRef.touched.dataType && Boolean(props.formRef.errors.dataType)}
              >
                <MenuItem value='string'>String</MenuItem>
                <MenuItem value='number'>Number</MenuItem>
                <MenuItem value='boolean'>Boolean</MenuItem>
                <MenuItem value='object'>Object</MenuItem>
              </Select>
            </Grid>
            <Grid xs={12} sm={6} item className={classes.root}>
              <TextField
                id='value'
                name='value'
                label='Value'
                value={props.formRef.values.value}
                onChange={props.formRef.handleChange}
                error={props.formRef.touched.value && Boolean(props.formRef.errors.value)}
                margin='dense'
                placeholder='Enter Longitude'
                variant='standard'
                fullWidth
              />
            </Grid>
          </Grid>
        </form>
      </CardContent>
    </StyledCard>
  );
}
